import { gql } from "@apollo/client";

export const RECORD_ENFORCEMENT_INTENT_PAYMENT = gql`
  mutation RecordEnforcementIntentPayment($id: uuid!, $paidAmount: Int!, $paidAt: timestamptz!) {
    record_enforcement_intent_payment(id: $id, paid_amount: $paidAmount, paid_at: $paidAt) {
      id
      enforcementIntentId: enforcement_intent_id
      paidAmount: paid_amount
      paidAt: paid_at
      paymentTransactionId: payment_transaction_id
      createdAt: created_at
      updatedAt: updated_at
    }
  }
`;

export interface RecordEnforcementIntentPaymentData {
  record_enforcement_intent_payment: {
    id: string;
    enforcementIntentId: string;
    paidAmount: number;
    paidAt: string;
    paymentTransactionId: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface RecordEnforcementIntentPaymentVars {
  id: string;
  paidAmount: number;
  paidAt: Date;
}

export default RECORD_ENFORCEMENT_INTENT_PAYMENT;
